export default function Footer() {
  return (
    <div className="credits">
      <i className="bx bx-copyright"></i> Copyright <a href="/" style={{fontWeight: "bold"}}>FMI.</a> {new Date().getFullYear()} All Rights Reserved
      {/* <br />
      <i className="bx bx-heart"></i> Designed by <a href="https://par.com.pk/" target="_blank" rel="noreferrer" style={{fontWeight: "bold"}}>Pakistan Agriculture Research</a> */}
    </div>
  )
}
